/*!
 * devextreme-vue
 * Version: 23.1.3
 * Build date: Fri Jun 09 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInnerChanges = exports.getConfig = exports.initOptionChangedFunc = exports.initDxConfiguration = void 0;
var vue_1 = require("vue");
var vue_helper_1 = require("./vue-helper");
var configuration_1 = require("./configuration");
function getConfig(vueInstance) {
    var componentOptions = (0, vue_helper_1.getNodeOptions)(vueInstance);
    if (!componentOptions) {
        return;
    }
    return componentOptions.$_config || vueInstance.$_config;
}
exports.getConfig = getConfig;
function getInnerChanges(vueInstance) {
    var componentOptions = (0, vue_helper_1.getNodeOptions)(vueInstance);
    if (!componentOptions) {
        return;
    }
    return componentOptions.$_innerChanges || vueInstance.$_innerChanges;
}
exports.getInnerChanges = getInnerChanges;
function initOptionChangedFunc(config, props, vueInstance, innerChanges) {
    if (!config) {
        return;
    }
    config.init(Object.keys(props));
    if (vueInstance) {
        (0, configuration_1.setEmitOptionChangedFunc)(config, vueInstance, innerChanges);
    }
}
exports.initOptionChangedFunc = initOptionChangedFunc;
function getComponentInfo(_a, removed) {
    var name = _a.name, isCollectionItem = _a.isCollectionItem, ownerConfig = _a.ownerConfig;
    var parentPath = ownerConfig && ownerConfig.fullPath;
    var optionPath = name && parentPath ? "".concat(parentPath, ".").concat(name) : name || "";
    return {
        optionPath: optionPath,
        isCollection: isCollectionItem,
        removed: removed
    };
}
function initDxConfiguration() {
    return (0, vue_1.defineComponent)({
        beforeMount: function () {
            var thisComponent = this;
            var config = getConfig(thisComponent);
            var innerChanges = getInnerChanges(thisComponent);
            initOptionChangedFunc(config, (0, vue_helper_1.getNodeTypeOfComponent)(thisComponent).props, thisComponent, innerChanges);
            (0, configuration_1.bindOptionWatchers)(config, this, innerChanges);
        },
        mounted: function () {
            if (this.$parent.$_instance) {
                this.$parent.$_config.componentsCountChanged
                    .push(getComponentInfo(getConfig(this)));
            }
        },
        beforeUnmount: function () {
            var config = getConfig(this);
            if (config) {
                this.$parent.$_config.componentsCountChanged
                    .push(getComponentInfo(config, true));
            }
        },
        render: function () {
            return null;
        }
    });
}
exports.initDxConfiguration = initDxConfiguration;
